/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogConsentDataContainer_user$ref: FragmentReference;
export type LogConsentDataContainer_user = {|
  +id: string,
  +$refType: LogConsentDataContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "LogConsentDataContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e4be365deebdcf4465922e6d56f2a146';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/__generated__/LogConsentDataContainer_user.graphql.js